import { AppState } from '../store';

export function getIsRefreshing(state: AppState) {
  return state.navigation.isRefreshing;
}
